import BrowerLogger from "alife-logger";
import { arms, armsEnvironment, version } from "@/config/env";

/**
 * @link https://help.aliyun.com/document_detail/66404.html
 */
const logger = (() => {
	if (arms) {
		try {
			return BrowerLogger.singleton({
				pid: "hccokn11qx@5784561a8f20268",
				imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
				enableSPA: true,
				sendResource: true,
				environment: armsEnvironment,
				release: version
			});
		} catch (e) {
			console.error("init logger fail", e);
		}
	} else {
		return {
			error() {}
		};
	}
})();

export default logger;
